import Appointment from "./appointment";
import PaymentStatus from "./payment";

export enum StatusPageType {
  PAYMENT,
  APPOINTMENT,
}

interface StatusPageProps {
  type: StatusPageType;
}

const STATUS_PAGE_MAP: Record<StatusPageType, JSX.Element> = {
  [StatusPageType.APPOINTMENT]: <Appointment />,
  [StatusPageType.PAYMENT]: <PaymentStatus />,
};

const StatusPage = ({ type }: StatusPageProps) => {
  return (
    <>
      <main className="gg-py-14 gg-flex gg-justify-center">
        {STATUS_PAGE_MAP[type]}
      </main>
    </>
  );
};

export default StatusPage;
